export default __webpack_public_path__ + "static/media/Kale.cf75dcd3.jpg";